import { z } from 'zod'

export const STRIPE_ACCOUNT_STATUSES = [
  'not_connected',
  'pending',
  'verified',
  'restricted',
] as const
export type StripeAccountStatus = (typeof STRIPE_ACCOUNT_STATUSES)[number]

export const stripeAccountStatusSchema = z.enum(STRIPE_ACCOUNT_STATUSES)

export const stripeConnectStepDataSchema = z.object({
  status: stripeAccountStatusSchema,
})

export type StripeConnectStepData = z.infer<typeof stripeConnectStepDataSchema>
